import { AnyAction } from "redux";
import { ShipmentStore } from "../../interfaces";
import { ShipmentTypes } from "../types";

const initialState: ShipmentStore = {
    weekData: null,
    yearData: null,
    loadingByDateRange: false,
    loadingOverview: false,
    successByDateRange: false,
    successOverview: false,
};

export const shipments = (
    state = initialState,
    action: AnyAction
): ShipmentStore => {
    switch (action.type) {
        case ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_LOADING:
            return {
                ...state,
                loadingByDateRange: true,
            };
        case ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_SUCCESS:
            return {
                ...state,
                weekData: action.payload.data,
                loadingByDateRange: false,
                successByDateRange: action.payload.success,
            };
        case ShipmentTypes.GET_SHIPMENTS_BY_DATE_RANGE_FAILURE:
            return {
                ...state,
                loadingByDateRange: false,
                successByDateRange: false,
            };
        case ShipmentTypes.GET_SHIPMENTS_OVERVIEW_LOADING:
            return {
                ...state,
                loadingOverview: true,
            };
        case ShipmentTypes.GET_SHIPMENTS_OVERVIEW_SUCCESS:
            return {
                ...state,
                yearData: action.payload.data,
                loadingOverview: false,
                successOverview: action.payload.success,
            };
        case ShipmentTypes.GET_SHIPMENTS_OVERVIEW_FAILURE:
            return {
                ...state,
                loadingOverview: false,
                successOverview: false,
            };
        default:
            return state;
    }
};
